<template>
    <div class="password-input-wrapper">
        <input
            :type="inputType"
            :value="value"
            :name="name"
            :id="id"
            :placeholder="placeholder"
            :required="required"
            :tabindex="tabindex"
            :autofocus="autofocus"
            @input="$emit('input', $event.target.value)"
            ref="input"
        />
        <button
            type="button"
            class="password-toggle"
            @click="toggleVisibility"
            :aria-label="showPassword ? 'Hide password' : 'Show password'"
            tabindex="-1"
        >
            <svg v-if="showPassword" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                <line x1="1" y1="1" x2="23" y2="23"></line>
            </svg>
            <svg v-else xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                <circle cx="12" cy="12" r="3"></circle>
            </svg>
        </button>
    </div>
</template>

<script>
export default {
    name: 'PasswordInput',
    props: {
        value: {
            type: String,
            default: ''
        },
        name: {
            type: String,
            default: ''
        },
        id: {
            type: String,
            default: ''
        },
        placeholder: {
            type: String,
            default: ''
        },
        required: {
            type: Boolean,
            default: false
        },
        tabindex: {
            type: [String, Number],
            default: null
        },
        autofocus: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            showPassword: false
        }
    },
    computed: {
        inputType () {
            return this.showPassword ? 'text' : 'password'
        }
    },
    methods: {
        toggleVisibility () {
            this.showPassword = !this.showPassword
        },
        focus () {
            this.$refs.input.focus()
        }
    }
}
</script>

<style scoped lang="scss">
@import 'public/css/vars.scss';

.password-input-wrapper {
    position: relative;
    width: 100%;

    input {
        padding-right: 5rem;
        width: 100%;
        border-color: $menu-right-border;
        color: $link-color-secondary;
        transition: border-color $transition;

        &:focus {
            border-color: $button-light-border-color;
            outline: none;
        }

        &::placeholder {
            color: fade-out($link-color-secondary, 0.5);
        }
    }

    .password-toggle {
        position: absolute;
        right: 1.5rem;
        top: 25px;
        transform: translateY(-50%);
        background: transparent;
        border: none;
        cursor: pointer;
        padding: 0.5rem;
        display: flex;
        align-items: center;
        justify-content: center;
        opacity: 0.6;
        transition: opacity 0.2s ease;
        width: auto;
        height: auto;
        margin: 0;
        box-shadow: none;

        &:hover {
            opacity: 1;
            box-shadow: none;
        }

        &:active {
            box-shadow: none;
        }

        &:focus {
            outline: none;
            box-shadow: none;
        }

        svg {
            width: 20px;
            height: 20px;
            stroke: $link-color-secondary;
        }
    }
}
</style>
